var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import ParagraphsWithIcon from '@declaration/components/ParagraphsWithIcon.vue';
const settings = namespace('settings');
let LeakageNotRepaired = class LeakageNotRepaired extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/pause-parcours.svg');
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get showCaseNumber() {
        var _a, _b, _c, _d, _e;
        return ((_e = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.shouldRepairLeakage) === null || _d === void 0 ? void 0 : _d.displayRememberContractNumber) !== null && _e !== void 0 ? _e : true);
    }
};
__decorate([
    settings.Getter('setting')
], LeakageNotRepaired.prototype, "setting", void 0);
LeakageNotRepaired = __decorate([
    Component({
        components: {
            ParagraphsWithIcon,
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
        },
    })
], LeakageNotRepaired);
export default LeakageNotRepaired;
